import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
// import { useTranslation } from 'react-i18next';
import Grid from '@clasohlson/co-ui-components/Grid';
import Column from '@clasohlson/co-ui-components/Column';
import Stack from '@clasohlson/co-ui-components/Stack';
import { SET_ORDER, useGlobalStateValue, SET_RETURN_QUERY } from '../../store/globalState';
import { getOrderByIdAndPostCode } from '../../api';
import { Error } from '../layout/Error';
import { Loader } from '../layout/Loader';
import { getParameterByName, useTranslation } from '../../utils';
import { CustomTextfield } from '../textfield/CustomTextfield';
import { CustomButton } from '../button/CustomButton';

export const OrderSearch = () => {
  // For testing
  // const [orderNr, setOrderNr] = useState<string>('459219056');
  // const [postCode, setPostCode] = useState<string>('12345');
  // const [orderNr, setOrderNr] = useState<string>('111115026');
  // const [postCode, setPostCode] = useState<string>('78475');

  const qOrderNr = getParameterByName('order');
  const qPostCode = getParameterByName('postcode');

  const [orderNr, setOrderNr] = useState<string>(qOrderNr || '');
  const [postCode, setPostCode] = useState<string>(qPostCode || '');
  const [postCodeError, setPostCodeError] = useState<string | undefined>();
  const [hasError, setHasError] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { dispatch } = useGlobalStateValue();

  const history = useHistory();
  const { t } = useTranslation();

  const handlePostCodeChange = (val: string) => {
    const stripped = val.replace(/\s+/g, '');
    setPostCode(stripped);
    const reg = new RegExp('^[0-9]+$');
    const numOnly = reg.test(stripped);
    if (!numOnly && stripped.length > 0) {
      setPostCodeError(t('errorNumbersOnly'));
    } else if (stripped.length > 0 && (stripped.length < 4 || stripped.length > 5)) {
      setPostCodeError(t('errorPostCodeFiveChars'));
    } else {
      setPostCodeError(undefined);
    }
  };

  const handleSearch = async (e: React.SyntheticEvent | undefined) => {
    e?.preventDefault();
    setHasError(false);
    setIsLoading(true);
    try {
      const data = await getOrderByIdAndPostCode(orderNr, postCode);
      dispatch({ type: SET_ORDER, payload: data });
      history.push('/select-products');
    } catch (e) {
      console.error(`Error when fetching order: ${e}`);
      setHasError(true);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    dispatch({ type: SET_RETURN_QUERY, payload: { orderNumber: orderNr, postCode } });
  }, [orderNr, postCode]);

  useEffect(() => {
    if (qOrderNr && qPostCode) handleSearch(undefined);
  }, [qOrderNr, qPostCode]);
  return (
    <form onSubmit={handleSearch}>
      <Stack spacing="medium">
        <Grid spacing="medium">
          <Column lg="6" md="6" sm="6" xs="6">
            <CustomTextfield
              label={t('orderNumber')}
              placeholder={t('orderNumber')}
              hideLabel
              value={orderNr}
              onChange={(e: any) => setOrderNr(e.currentTarget.value)}
              data-testid="orderNumber"
            />
          </Column>
          <Column lg="6" md="6" sm="6" xs="6">
            <CustomTextfield
              label={t('postCode')}
              placeholder={t('postCode')}
              hideLabel
              value={postCode}
              error={postCodeError}
              onChange={(e: any) => handlePostCodeChange(e.currentTarget.value)}
              data-testid="orderPostCode"
            />
          </Column>
        </Grid>
        <div>
          <CustomButton
            style={{ width: '100%' }}
            fullWidth
            type="submit"
            disabled={orderNr.length === 0 || postCode.length === 0 || isLoading}
            data-testid="searchOrderButton"
          >
            {!isLoading && t('findOrder')}
            {isLoading && <Loader />}
          </CustomButton>
          {hasError && (
            <Error>
              {t('orderErrorPart1')}
              <a href={t('orderErrorPart2')} target="_blank">
                {t('orderErrorPart3')}
              </a>
              {t('orderErrorPart4')}
            </Error>
          )}
        </div>
      </Stack>
    </form>
  );
};
